<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-6 mt-2 mt-8 sm:-mt-px">
        <div class="font-bold pt-6 text text-blue-500 tracking-wide uppercase">
            {{ $t('Feasibility / Due-Diligence Period') }}
        </div>

        <feasibility-period-date
            :commercial="commercial"
            :read_only="read_only"
            @updated="updatedFeasibilityDate"
        />

        <feasibility-period-extend
            v-model="feasibility_extend_days"
            :commercial="commercial"
            :feasibility_date="feasibility_date"
            :read_only="read_only"
        />
    </div>
</template>

<script>
import FeasibilityPeriodDate from './feasibility-period-date.vue';
import FeasibilityPeriodExtend from './feasibility-period-extend.vue';

export default {
    components: {
        FeasibilityPeriodDate,
        FeasibilityPeriodExtend,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            feasibility_date: this.commercial.feasibility_date,
            feasibility_extend_days: this.commercial.feasibility_extend_days,
        }
    },

    methods: {
        updatedFeasibilityDate(value) {
            this.feasibility_date = value;
        },
    },
}
</script>
